import { render, staticRenderFns } from "./TradeResultDivisibleVolume.vue?vue&type=template&id=4ff03dc3&scoped=true&"
import script from "./TradeResultDivisibleVolume.vue?vue&type=script&lang=js&"
export * from "./TradeResultDivisibleVolume.vue?vue&type=script&lang=js&"
import style0 from "./TradeResultDivisibleVolume.vue?vue&type=style&index=0&id=4ff03dc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff03dc3",
  null
  
)

export default component.exports